export let MASKS = {
  phoneExt: "(###) ###-#### ext. ################################",
  phone: "(###) ###-####",
  number: "####",
  phonekeypad: {
    mask: "@@@@@@@@@@",
    tokens: {
      "@": { pattern: /\d|\*|#/ }
    }
  },
  nomask: {
    mask: "*".repeat(500),
    tokens: {
      "*": { pattern: /./ }
    }
  }
};
